/**
 * @param {*} urlParams
 * @param {*} appliedParams
 * @returns
 */
export const getReplaceURL = (urlParams, appliedParams) => {
  // Set sortBy and sortOrder parameters directly
  urlParams.set("sortBy", appliedParams.sortBy);
  urlParams.set("sortOrder", appliedParams.sortOrder);

  const newSearch = urlParams.toString();
  const url = `${window.location.pathname}${newSearch ? `?${newSearch}` : ""}`;
  return url;
};
